import type { Pinia } from 'pinia'
import { watch } from 'vue'
import { printHtml as vxePrintHtml } from 'vxe-pc-ui/es/print/src/util'
import VxeUITable, { VxeUI } from 'vxe-table'
import { useAppSettingsStore } from '@/store/modules/app/settings'

export function setupVxeTable(pinia: Pinia) {
  Object.assign(VxeUI, { print: vxePrintHtml })
  VxeUITable.setConfig({
    table: {
      stripe: false,
      border: false,
      autoResize: true,
      showOverflow: 'title',
      showHeaderOverflow: 'title',
      showFooterOverflow: 'title',
      resizeConfig: {
        refreshDelay: 20,
      },
      rowConfig: {
        useKey: true,
      },
      columnConfig: {
        useKey: true,
        resizable: true,
      },
      menuConfig: {
        destroyOnClose: true,
      },
    },
  })

  const appSettingsStore = useAppSettingsStore(pinia)
  watch(() => appSettingsStore.currentColorScheme, (colorScheme) => {
    VxeUITable.setTheme(colorScheme ?? 'light')
  }, { immediate: true })
}
